import { z } from "zod";

export const RiseConnectionStatus = {
  ONLINE: "online",
} as const;
export type RiseConnectionStatus = (typeof RiseConnectionStatus)[keyof typeof RiseConnectionStatus];

export const RisePrepareResultSchema = z.object({
  prepareId: z.string().uuid(),
  agentAddress: z.string().min(1),
  eip712TypedData: z.object({
    types: z.record(z.string(), z.array(z.object({ name: z.string(), type: z.string() }))),
    primaryType: z.string(),
    domain: z.object({
      name: z.string(),
      version: z.string(),
      chainId: z.number(),
      verifyingContract: z.string(),
    }),
    message: z.record(z.string(), z.unknown()),
  }),
});
export type RisePrepareResultDto = z.infer<typeof RisePrepareResultSchema>;

export const AddRiseAccountSchema = z.object({
  accountId: z.number().int().positive(),
  walletAddress: z.string().min(1),
  status: z.enum(Object.values(RiseConnectionStatus) as [string, ...string[]]),
  transactionHash: z.string().optional(),
});
export type AddRiseAccountDto = z.infer<typeof AddRiseAccountSchema>;
